//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Field,
  Button,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Popup,
  Loading,
  Picker,
  Uploader,
  Dialog,
  Toast
} from "vant";
import global from '../../../static/js/global.js'
import Qs from "qs";
import vueQr from 'vue-qr';
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Loading.name]: Loading,
    [Picker.name]: Picker,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [vueQr.name]: vueQr,
  },
  data() {
    return {
      //二维码code
      imgUrl:"../../../static/image/house_icon.png",
      codeText: "",
      openId: "",
      status: false,
    };
  },
  mounted() {
    Toast.loading({
      message: '加载中...',
      forbidClick: false,
      duration: 500
    });
    document.title="门禁二维码"
    this.openId = this.$router.history.current.query.openid;
    this.load();
  },
  methods: {
    //初始化二维码
    load(){
        this.$http.get(global.host + 'guardCard/qrcode?openid='+this.openId).then(function(res){
            console.log("res   ===   "+JSON.stringify(res));
            if(res.body.code == "200"){
                if(res.body.data){
                    this.status = false;
                    this.codeText = res.body.data;
                }else{
                    this.status = true;
                }
            } else {
              this.status = true;
            }
            console.log(" this.codeText   ===   "+this.codeText)
        },function(err){
          Toast.loading({
            message: '服务异常，请稍后重试',
            forbidClick: false,
            duration: 3000
          });

        })
    },
    //刷新二维码
    refresh(){
      Toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 500
      });
      this.load();
    }
  }

};



// WEBPACK FOOTER //
// ./src/components/accessControl/accessCode.vue